import React, { useState } from 'react';

import BarChartHealthWrapper from '../barChartHealthWrapper/barChartHealthWrapper';
import MapChartHealthWrapper from '../mapChartHealthWrapper/mapChartHealthWrapper';
import LineChartHealthWrapper from '../lineChartHealthWrapper/lineChartHealthWrapper';

import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';
import DataMethodLink from '../dataMethodLink/dataMethodLink';

// chart data
import Frage_3_Unterste_Einkommen_nominal from 'data/Frage-3_Unterste_Einkommen_nominal.json';
import Frage_3_Unterer_Mittelstand_nominal from 'data/Frage-3_Unterer_Mittelstand_nominal.json';
import Frage_3_Oberer_Mittelstand_nominal from 'data/Frage-3_Oberer_Mittelstand_nominal.json';
import Frage_3_Oberste_Einkommen_nominal from 'data/Frage-3_Oberste_Einkommen_nominal.json';

import Frage_3_Unterste_Einkommen_real from 'data/Frage-3_Unterste_Einkommen_real.json';
import Frage_3_Unterer_Mittelstand_real from 'data/Frage-3_Unterer_Mittelstand_real.json';
import Frage_3_Oberer_Mittelstand_real from 'data/Frage-3_Oberer_Mittelstand_real.json';
import Frage_3_Oberste_Einkommen_real from 'data/Frage-3_Oberste_Einkommen_real.json';

const ChartHealth3Wrapper = () => {
  const questionId = 3;
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const dataFilesNominal = [
    Frage_3_Unterste_Einkommen_nominal,
    Frage_3_Unterer_Mittelstand_nominal,
    Frage_3_Oberer_Mittelstand_nominal,
    Frage_3_Oberste_Einkommen_nominal,
  ];

  const dataFilesReal = [
    Frage_3_Unterste_Einkommen_real,
    Frage_3_Unterer_Mittelstand_real,
    Frage_3_Oberer_Mittelstand_real,
    Frage_3_Oberste_Einkommen_real,
  ];

  return (
    <div>
      <ChartTitleIntro number={questionId} title="Wer erhält und wer bezahlt Prämienverbilligungen?">
        <p>
          Die folgenden Grafiken zeigen die Umverteilungswirkung der individuellen Prämienverbilligungen (IPV). Ist der Betrag positiv, dann trägt
          diese Gruppe über die Steuern mehr zur Finanzierung bei, als sie an Zahlungen erhält. Ist der Betrag negativ, dann trägt diese Gruppe über
          die Steuern weniger zur Finanzierung bei, als sie an Zahlungen erhält.
        </p>
        <p>
          <em>
            Grafik 3.1 ermöglicht einen Vergleich zwischen den Einkommensgruppen innerhalb eines Kantons. Grafik 3.2 erlaubt einen interkantonalen
            Vergleich der Umverteilungswerte. In Grafik 3.3 ist die Entwicklung der Umverteilung über die Zeit abgebildet (real, zu Preisen des
            jüngsten verfügbaren Jahres). Hier erfahren Sie mehr zu <DataMethodLink />.
          </em>
        </p>
      </ChartTitleIntro>

      <div className="charttabs">
        <div className="charttabs-tabs uppercase">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => setSelectedTab(0)}>
            {questionId}.1 Vergleich Einkommensgruppen
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => setSelectedTab(1)}>
            {questionId}.2 Interkantonaler Vergleich
          </div>
          <div className={`charttabs-tab ${selectedTab === 2 ? 'active' : ''}`} onClick={() => setSelectedTab(2)}>
            {questionId}.3 Entwicklung über die Zeit
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.1 GRUPPENVERGLEICH UMVERTEILUNG PRÄMIENVERBILLIGUNGEN</div>
            <BarChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Umverteilung Prämienverbilligungen" />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.2 INTERKANTONALER VERGLEICH UMVERTEILUNG PRÄMIENVERBILLIGUNGEN</div>
            <MapChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Umverteilung Prämienverbilligungen" />
          </div>
          <div className={`${selectedTab === 2 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.3 ENTWICKLUNG UMVERTEILUNG PRÄMIENVERBILLIGUNGEN</div>
            <LineChartHealthWrapper dataFiles={dataFilesReal} titlePrefix="Umverteilung Prämienverbilligungen" />
          </div>
        </div>
      </div>
      <div className="d-md-none align-center">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default ChartHealth3Wrapper;
